import React, { useContext } from 'react';
import { ContentBox } from '../ContentBox/ContentBox';
import { useGetLoanDocByLoan } from 'services/loan/querys';
import { TaskOpenModalContext } from 'scenes/Private/Private';
import { LoanDocState, TaskState } from 'gql/graphql';
import { buildDocItems, Item } from '@common/utils/helpers/buildDocItem';

interface IProps {
  loanSelected: any;
  tasks: any;
}

// Configuración de estados para appraisal
export const APPRAISAL_STATES = {
  appraisal: {
    [LoanDocState.Pending]: 'Not Ordered',
    [LoanDocState.Ordered]: 'Ordered', 
    [LoanDocState.Received]: 'Received',
    [LoanDocState.Approved]: 'Approved',
    default: 'Not Ordered'
  }
};

export const BoxLoanDocuments: React.FC<IProps> = ({ loanSelected, tasks }: IProps) => {

  const { setHandler: openTask }: any = useContext(TaskOpenModalContext);

  const { data: loanDocs } = useGetLoanDocByLoan({ 
    variables: { loanId: loanSelected._id },
  });

  const findDoc = (
    key: string,
    extraCondition: (doc: any) => boolean = () => true
  ) =>
    loanDocs?.find(
      (doc: any) =>
        doc.key === key &&
        extraCondition(doc)
    );

  const termSheet = findDoc("term_sheet", doc => !doc.isDeleted);
  const preApproval = findDoc("pre_approval");
  const appraisal = findDoc("appraisal");
  const appraisalTask = tasks.find((item: any) => item.key === 'pay_appraisal');
  const closingDocs = findDoc("closing_docs");

  const otherDocuments =
    loanDocs?.filter(
      (doc: any) =>
        !["term_sheet", "pre_approval", "appraisal", "closing_docs"].includes(
          doc.key
        ) && !doc.hidden
    ) ?? [];
  
  const isAppraisalDocVisible = appraisal && !appraisal.hidden && ((appraisal?.state as any) === LoanDocState.Approved);
  const isAppraisalTaskApproved = (appraisalTask?.state as any) === TaskState.Approved;

  const states = APPRAISAL_STATES.appraisal;
  const stateAppraisalDoc = APPRAISAL_STATES.appraisal[appraisal?.state as keyof typeof states] || states.default;

  const valueCustomForAppraisal = () => {
    if (isAppraisalTaskApproved && !isAppraisalDocVisible) {
      return <i>Available after appraisal is verified</i>
    }
    if (isAppraisalTaskApproved && isAppraisalDocVisible) {
      return undefined;
    }
    if (appraisalTask?.state !== TaskState.Approved && appraisalTask?.state !== TaskState.Review) {
      return <span onClick={() => openTask('pay_appraisal')}>{"Pay appraisal ->"}</span>
    }
    return <i>Available after appraisal is verified</i>
  }

  const loanDocumentsContent: Item[] = [
    ...buildDocItems("Term sheet", termSheet, undefined, "", <i>Available after Term sheet</i>, termSheet ? true : false),

    ...otherDocuments.flatMap((doc: any) => buildDocItems(doc.name, doc)),

    ...buildDocItems("Pre-approval letter", preApproval, undefined, "", <i>Available after Pre-approval letter</i>, preApproval ? true : false),

    ...buildDocItems("Appraisal", appraisal, {state: stateAppraisalDoc}, "",
        valueCustomForAppraisal(), isAppraisalTaskApproved && isAppraisalDocVisible
      ),

    ...buildDocItems("Closing documents", closingDocs, undefined, "",
        <i>Available after Closing</i>, closingDocs && !closingDocs?.hidden ? true : false),
  ];

  return (
    <ContentBox
      label={'Loan documents'}
      content={loanDocumentsContent}
      isBoxLoanDocuments={true}
    />
  );
}